var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-calendar-list-item", {
    attrs: {
      name: _vm.calendar.summary,
      active: _vm.active,
      color: _vm.calendar.backgroundColor,
      editable: "",
    },
    on: {
      load: function ($event) {
        return _vm.load()
      },
      edit: function ($event) {
        return _vm.edit()
      },
      remove: function ($event) {
        return _vm.remove()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }